<template>
  <div class="background bg-dark">
    <h3 style="color: #fff">Bubble Game</h3>
    <h1 style="color: #ff6688">Click to see bubble pop out!</h1>

    <div
      id="bubbleapp"
      class="background"
      @click="createBubble($event)"
      style="position: relative"
    >
      <div
        v-for="bubble in bubbles"
        :key="bubble.id"
        :style="{
          position: 'absolute',
          left: `${bubble.x}px`,
          top: `${bubble.y}px`,
          width: `${bubble.size}px`,
          height: `${bubble.size}px`,
          backgroundColor: bubble.color,
          border: `5px solid ${bubble.borderColor}`,
          opacity: bubble.opacity,
        }"
        class="absolute rounded-full transition-all duration-300"
        @click="popBubble(bubble.id)"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.background {
  background-color: #343a40;
  margin: 0;
  overflow: hidden; /* Prevent overflow */
  position: relative; /* Ensures child elements are positioned correctly */
}

#bubbleapp {
  position: relative;
  width: 100%; /* Full width */
  height: 100vh; /* Full height of the viewport */
}

.absolute {
  transition: transform 1s, opacity 0.5s;
  border-radius: 50%;
  position: absolute; /* Make sure the bubbles are positioned correctly */
}

.absolute:hover {
  transform: scale(1.2);
  opacity: 0.8;
}
</style>

<script>
export default {
  data() {
    return {
      bubbles: [], // Array to store all active bubbles
      idCounter: 0, // Unique ID for each bubble
    };
  },
  methods: {
    createBubble(event) {
      const bubbleApp = document.getElementById("bubbleapp");
      const rect = bubbleApp.getBoundingClientRect(); // Get position and size of the container
      const size = Math.random() * 50 + 20;
      const color = `hsl(${Math.random() * 360}, 100%, 70%)`;
      const borderColor = `hsl(${Math.random() * 360}, 100%, 50%)`;

      // Calculate mouse position relative to the container
      const x = event.clientX - rect.left - size / 2;
      const y = event.clientY - rect.top - size / 2;

      const newBubble = {
        id: this.idCounter++,
        x: x,
        y: y,
        size,
        color,
        borderColor,
        opacity: 1,
      };

      this.bubbles.push(newBubble);

      // If the bubble is large, add small bubbles around it
      if (size > 40) {
        this.createSmallBubbles(newBubble);
      }
    },

    createSmallBubbles(parentBubble) {
      const numberOfSmallBubbles = 5; // Number of small bubbles around a large bubble

      for (let i = 0; i < numberOfSmallBubbles; i++) {
        const size = Math.random() * 20 + 10; // Small bubble size
        const randomAngle = Math.random() * 2 * Math.PI; // Random angle to spread around the parent bubble
        const distance = Math.random() * (parentBubble.size * 0.6) + 15; // Increase the spread

        // Calculate the new position based on the angle and distance
        const smallBubbleX = parentBubble.x + Math.cos(randomAngle) * distance;
        const smallBubbleY = parentBubble.y + Math.sin(randomAngle) * distance;

        const smallBubble = {
          id: this.idCounter++,
          x: smallBubbleX, // Position around the parent bubble
          y: smallBubbleY,
          size,
          color: parentBubble.color, // Same color as parent bubble
          borderColor: parentBubble.borderColor, // Same border color as parent
          opacity: 0.8, // Make small bubbles slightly transparent
        };

        this.bubbles.push(smallBubble);
      }
    },

    popBubble(id) {
      this.bubbles = this.bubbles.filter((bubble) => bubble.id !== id);
    },

    animateBubbles() {
      this.bubbles.forEach((bubble) => {
        bubble.y -= 1; // Move bubble upwards slowly
        if (bubble.y + bubble.size < 0) {
          this.popBubble(bubble.id); // Remove bubble if it moves off-screen
        }
      });

      // Recursively call the animation loop
      requestAnimationFrame(() => this.animateBubbles());
    },
  },

  mounted() {
    // Animation loop to move the bubbles upwards
    this.animateBubbles();
  },
};
</script>
